<template>
  <div class="custom-select-element" :tabindex="tabindex" @blur="handleBlur" :class="customClass">
    <div
      class="selected truncate"
      :class="{ open: open, active: checkedList && checkedList.length }"
      @click="open = !open"
    >
      {{ checkedList && checkedList.length ? 'Filter Selected' : 'View by category' }}
    </div>
    <div class="items" :class="{ selectHide: !open }">
      <label
        v-for="(option, i) of options"
        :key="i"
        class="text-sm option darker-hover d-flex align-items-center"
      >
        <input
          :id="option.value"
          class="mr-2"
          type="checkbox"
          :value="option"
          v-model="checkedList"
        />
        <span>{{ option.text }}</span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'custom-select-element',
  props: {
    customClass: String,
    options: {
      type: Array,
      required: true,
    },
    closeOnSelect: {
      type: Boolean,
      required: false,
      default: false,
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      open: false,
      checkedList: [],
    };
  },
  methods: {
    handleBlur() {
      this.open = false;
    },
  },
  watch: {
    checkedList() {
      this.open = !this.closeOnSelect || false;
      this.$emit('onChangeChecked', this.checkedList);
    },
  },
};
</script>

<style scoped lang="scss">
.extra-element {
  color: grey;
  opacity: 0.5;
}
.custom-select-element {
  position: relative;
  width: 100%;
  text-align: left;
  outline: none;
  height: 42px;
  line-height: 42px;
  min-width: 180px;
  max-width: 300px;

  @media (max-width: 576px) {
    max-width: 100%;
  }
}

.custom-select-element .selected {
  background-color: #ffffff;
  border-radius: 8px;
  border: 1px solid #e6e6ff;
  color: #a7a7bc;
  padding: 0 1em;
  cursor: pointer;
  height: 100%;
  user-select: none;

  display: flex;
  justify-content: center;
}

.custom-select-element .items {
  color: #000000;
  border-radius: 0px 0px 8px 8px;
  overflow: hidden;
  border-radius: 8px;
  border: 1px solid #e6e6ff;
  position: absolute;

  background-color: #ffffff;
  left: 0;
  right: 0;
  z-index: 1;
}

.custom-select-element .items .option {
  padding-left: 1em;
  padding-right: 1em;
  cursor: pointer;
}

.custom-select-element .active {
  border: #6fa6a3 1px solid;
  color: #6fa6a3 !important;
}

.selectHide {
  display: none;
}
</style>
